import createStore from "redux-zero";
import {applyMiddleware} from "redux-zero/middleware";
import {connect} from "redux-zero/devtools";
import {QueryState} from "../models/query";
import {FilterMap} from "../models/filter";
import {getStateFromStorage} from "./persist-middleware";
import {Gender, Product} from "../models/product";
import {Like} from "../models/customer";
import {Collection} from "../models/collection";

export class AppState {
  public initialized: boolean             = false;
  public isFilterDisplayed: boolean       = true;
  public isFilterModalDisplayed: boolean  = false;
  public desktopColumnCount: number       = 3;
  public lastScrollPosition: number       = 0;
  public products: QueryState             = new QueryState(-1, [], 30, 0);
  public filters: FilterMap               = new FilterMap(Gender.Female, "");
  public likes: Like[]                    = [];
  public isInterstitialOpen: boolean      = false;
}

const initialState: AppState = new AppState();

const middlewares = [];
if (connect) {
  middlewares.push(connect(initialState));
}

const store = createStore(initialState, applyMiddleware(...middlewares));

export default store;
